import API from "../../utils/api";

export const getGoddivaUsProductsApi = async (data) => {
  const response = await API.get(`goddiva-us-products`, { params: data });
  return { response };
};

export const getGoddivaUsProductVariantsApi = async (productId, data = {}) => {
  const response = await API.get(`goddiva-us-products/${productId}/variants`, {
    params: data,
  });
  return { response };
};

export const resyncGoddivaUsProductApi = async (productId) => {
  const response = await API.post(`goddiva-us-products/${productId}/resync`);
  return { response };
};

export const syncGoddivaUsImagesApi = async (productId) => {
  const response = await API.post(`goddiva-us-products/${productId}/sync-images`);
  return { response };
};

// Bulk re-sync (inventory + images). Pass either { product_ids: [...] } or
// { select_all: true, filters: {...} } to queue every product matching the filters.
export const bulkResyncGoddivaUsProductsApi = async (data) => {
  const response = await API.post(`goddiva-us-products/bulk-resync`, data);
  return { response };
};

// Current/most-recent bulk run, used to restore progress after a page refresh.
export const getGoddivaUsBulkStatusApi = async () => {
  const response = await API.get(`goddiva-us-products/bulk-resync/status`);
  return { response };
};
